/**
 * App layer marker. Radix modal Dialog/Sheet set `pointer-events:none` on
 * everything outside their content and treat any pointer/focus outside as a
 * dismiss. Custom pop-ups rendered via createPortal(document.body) land
 * outside, so every such pop-up root spreads `appLayerProps`: base.css gives
 * it `pointer-events:auto`, and Dialog/Sheet exempt it from outside-dismiss.
 */
export const APP_LAYER_ATTR = 'data-app-layer';
export const appLayerProps = { [APP_LAYER_ATTR]: '' } as const;

const EXEMPT_SELECTOR = `[${APP_LAYER_ATTR}], [data-colorpicker-panel], [data-searchable-select-menu]`;

export function isInsideAppLayer(target: EventTarget | null): boolean {
  return target instanceof Element && !!target.closest(`[${APP_LAYER_ATTR}]`);
}

/** True when a Radix outside-interaction event targets a kit/app pop-up layer. */
export function isExemptOutsideTarget(e: Event): boolean {
  const t = e.target;
  return isInsideAppLayer(t) || (t instanceof Element && !!t.closest(EXEMPT_SELECTOR));
}
